import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { initRollbar } from "./utils/rollbar";
import { analyticsService } from "./services/AnalyticsService";




analyticsService.init();
initRollbar(process.env.REACT_APP_ENV, process.env.REACT_APP_ROLLBAR_TOKEN, process.env.REACT_APP_GIT_COMMIT);

if (process.env.REACT_APP_ENV === 'main') {
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals